import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "./motion";
import { startCheckout } from "./payments";

const PRODUCTS = [
    {
        name: "Vitamin C",
        tag: "Brighten & even",
        price: "$59",
        lookup: "vitamin_c_serum",
        img: "https://static.prod-images.emergentagent.com/jobs/042f1a63-d502-4eb1-8de6-71e5b27c4c81/images/24732596e7ef476a2b5beef07ed66ba460973db22c5e0c442c7873f689b5a3cc.jpeg",
    },
    {
        name: "Sunscreen",
        tag: "Daily SPF",
        price: "$39",
        lookup: "sunscreen_spf",
        img: "https://static.prod-images.emergentagent.com/jobs/042f1a63-d502-4eb1-8de6-71e5b27c4c81/images/82dcc9503baa2b5d5d31bec9e14c8fe824be9fa6b994d727b1dad0dd5261d7b4.jpeg",
    },
];

export default function Store() {
    return (
        <section
            id="store"
            data-testid="store-section"
            className="bg-linen px-6 py-24 md:px-12 md:py-36"
        >
            <div className="mx-auto max-w-[1440px]">
                <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
                    <div>
                        <Eyebrow index="04">The In Skin store</Eyebrow>
                        <Reveal delay={0.1}>
                            <h2 className="mt-8 font-serif text-[clamp(2.2rem,4.5vw,4.25rem)] font-light leading-[1.05] text-ink">
                                Loved on <span className="italic text-earth">the feed.</span>
                            </h2>
                        </Reveal>
                    </div>
                    <Reveal delay={0.2}>
                        <p className="max-w-xs text-sm font-light leading-relaxed text-earth">
                            The formulas our clients ask about most — as seen on
                            @inskinau.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 md:mt-20 md:gap-8">
                    {PRODUCTS.map((p, i) => (
                        <Reveal
                            key={p.name}
                            delay={i * 0.12}
                            testid={`store-product-card-${i + 1}`}
                        >
                            <div className="group relative overflow-hidden rounded-[28px] ring-1 ring-ink/10">
                                <img
                                    src={p.img}
                                    alt={`${p.name} cream texture`}
                                    loading="lazy"
                                    className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                />
                                <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                                    <div className="flex h-56 w-56 items-center justify-center rounded-full border border-cream/90 md:h-64 md:w-64">
                                        <span className="rounded-full bg-cream/90 px-6 py-2.5 font-sans text-sm font-medium uppercase tracking-[0.3em] text-ink md:text-base">
                                            {p.name}
                                        </span>
                                    </div>
                                </div>
                                <div className="pointer-events-none absolute inset-x-6 bottom-6 flex items-center justify-between gap-3">
                                    <span className="rounded-full bg-ink/85 px-5 py-2 font-sans text-[10px] uppercase tracking-[0.25em] text-cream">
                                        {p.tag}
                                    </span>
                                    <button
                                        data-testid={`store-buy-button-${i + 1}`}
                                        onClick={() => startCheckout(p.lookup)}
                                        className="rounded-full bg-cream px-6 py-2.5 font-sans text-[11px] font-medium uppercase tracking-[0.2em] text-ink transition-all duration-300 hover:-translate-y-0.5 hover:bg-sand hover:shadow-xl"
                                    >
                                        Buy · {p.price}
                                    </button>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <div className="mt-14 flex justify-center">
                        <a
                            data-testid="store-external-button"
                            href="https://www.instagram.com/inskinau"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-3 rounded-full bg-ink px-10 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-earth hover:shadow-xl"
                        >
                            Explore our store
                            <ArrowUpRight size={15} strokeWidth={1.5} />
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
